import React from 'react';
import { Helmet } from 'react-helmet';
import localsearchLogo from '../../assets/branding/localsearch-logo.jpg';
import config from '../../../src/client/config';

const { urlRoot } = config;

const Meta = () => {
  const description =
    "Search locally for a quick, easy and cost-effective solution to all of life's unwanted hassles such as finding a removalist, installing a towbar and even renovating a kitchen.";

  return (
    <Helmet>
      <title>Information & Cost Guides in Australia | Localsearch</title>
      <meta name="description" content={description} />
      <meta name="COPYRIGHT" content="Localsearch" />
      <meta name="AUTHOR" content="Localsearch" />
      <meta name="RESOURCE-TYPE" content="DOCUMENT" />
      <meta name="DISTRIBUTION" content="GLOBAL" />
      <meta name="RATING" content="GENERAL" />
      <meta
        property="og:title"
        content="Information & Cost Guides in Australia | Localsearch"
      />
      <meta property="og:type" content="company" />
      <meta property="og:image" content={`${urlRoot}/${localsearchLogo}`} />
      <meta property="og:url" content={`${urlRoot}/guides`} />
      <meta property="og:site_name" content="Localsearch" />
      <meta property="og:description" content={description} />
      <link rel="canonical" href={`${urlRoot}/guides`} />
    </Helmet>
  );
};

export default Meta;
